import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';
import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import uniqBy from 'lodash/uniqBy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { IconPanel } from 'common/components/icons';

const countPanelPerSegmentsById = (id, segments) => {
    const filteredSegments = segments.filter(
        (segment) => segment.panel?.id === id,
    );

    const quantityEnabledModules = filteredSegments.reduce(
        (acc, current) => acc + current.quantity_enabled_modules,
        0,
    );

    return quantityEnabledModules;
};

const PanelsCard = ({ offerPanels, segments }) => {
    const { t } = useTranslation();
    return (
        <>
            <Box sx={{ alignItems: 'center', display: 'flex', gap: 1, mb: 2 }}>
                <IconPanel color="#2AA1E0" />
                <Typography variant="body2" fontWeight="bold">
                    {t('Panel', { count: 2 })}
                </Typography>
            </Box>

            {uniqBy(offerPanels, 'id').map((item, index) => (
                <Box
                    key={`offer-panel-${index}`}
                    p={1}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        ml: '16px',
                        mb: 2,
                    }}
                >
                    <Box
                        alignItems="center"
                        display="flex"
                        gap={1}
                        sx={{ ml: '-1rem' }}
                    >
                        <CircleIcon sx={{ fontSize: '0.6rem' }} />
                        <Typography variant="caption" fontWeight="bold">
                            {item?.name || 'N/A'}
                        </Typography>
                    </Box>

                    <Box alignItems="center" display="flex" gap={1}>
                        <Typography variant="caption">
                            <Typography
                                component="span"
                                fontWeight="bold"
                                variant="caption"
                            >
                                {t('Length')}:{' '}
                            </Typography>
                            {item?.height} mm
                        </Typography>

                        <Typography variant="caption">
                            <Typography
                                component="span"
                                fontWeight="bold"
                                variant="caption"
                            >
                                {t('Width')}:{' '}
                            </Typography>
                            {item?.width} mm
                        </Typography>
                    </Box>

                    <Typography variant="caption">
                        {t('Assigned', { count: 2 })}:{' '}
                        {countPanelPerSegmentsById(item?.id, segments)}
                    </Typography>

                    <Typography variant="caption">
                        {(countPanelPerSegmentsById(item?.id, segments) *
                            item?.max_power) /
                            1000}{' '}
                        kW
                    </Typography>
                </Box>
            ))}
        </>
    );
};

PanelsCard.propTypes = {
    offerPanels: PropTypes.array,
    segments: PropTypes.array,
};

export default PanelsCard;
